export default __webpack_public_path__ + "static/media/promo-facilitator.d3d5191b.png";